export default "__VITE_ASSET__BJUeD0bm__"